function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cx from 'classnames';
import { TERRITORIES_KEYS } from "./constants";
import ListHeader from "./list-header/list-header";
import UndoLink from "./undo-link/undo-link";
import MoveCountryButton from "./move-country-button/move-country-button";
import TerritoriesList from "./territories-list/territories-list";

var TerritoriesListManager =
/*#__PURE__*/
function (_Component) {
  _inherits(TerritoriesListManager, _Component);

  function TerritoriesListManager(props) {
    var _this;

    _classCallCheck(this, TerritoriesListManager);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TerritoriesListManager).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getUndoLinkStatus", function () {
      var _this$props = _this.props,
          undoNotificationVisible = _this$props.undoNotificationVisible,
          movedCountriesNumber = _this$props.movedCountriesNumber;
      return undoNotificationVisible && movedCountriesNumber > 0;
    });

    _defineProperty(_assertThisInitialized(_this), "handleTerritorySearch", function (text) {
      var searchedCountries = _this.findTerritory(_this.props.countries, text);

      _this.setState({
        searchQuery: text,
        searchedCountries: searchedCountries
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTerritorySearchClose", function () {
      var onTerritorySearchClose = _this.props.onTerritorySearchClose;

      _this.setState({
        searchQuery: ''
      });

      if (onTerritorySearchClose) onTerritorySearchClose();
    });

    _defineProperty(_assertThisInitialized(_this), "findTerritory", function (territories, text) {
      return territories.filter(function (territory) {
        var _this$props2 = _this.props,
            territoryNameKey = _this$props2.territoryNameKey,
            continentNameKey = _this$props2.continentNameKey;
        var territoryName = territory[territoryNameKey],
            continent = territory[continentNameKey];
        var regEx = new RegExp(text.toLowerCase());
        return regEx.test(territoryName.toLowerCase()) || regEx.test(continent.toLowerCase());
      });
    });

    _this.state = {
      searchQuery: '',
      searchedCountries: null
    };
    return _this;
  }

  _createClass(TerritoriesListManager, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setState({
        searchedCountries: this.props.countries
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var countries = nextProps.countries;
      var searchQuery = this.state.searchQuery;
      if (searchQuery.length === 0) this.setState({
        searchedCountries: countries
      });else this.setState({
        searchedCountries: this.findTerritory(countries, searchQuery)
      });
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      var searchQuery = this.state.searchQuery;
      var nextQuery = nextState.searchQuery; // eslint-disable-next-line react/no-will-update-set-state

      if (searchQuery && !nextQuery) this.setState({
        searchedCountries: this.props.countries
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          thisListType = _this$props3.thisListType,
          theOtherListType = _this$props3.theOtherListType,
          header = _this$props3.header,
          onUndoNotificationClose = _this$props3.onUndoNotificationClose,
          totalNumberOfCountries = _this$props3.totalNumberOfCountries,
          movedCountriesNumber = _this$props3.movedCountriesNumber,
          selectedCountries = _this$props3.selectedCountries,
          onTerritoryMovedUndo = _this$props3.onTerritoryMovedUndo,
          onTerritoryMove = _this$props3.onTerritoryMove,
          onCountrySelect = _this$props3.onCountrySelect,
          countries = _this$props3.countries,
          theOtherListLabel = _this$props3.theOtherListLabel,
          forward = _this$props3.forward,
          territoryIdKey = _this$props3.territoryIdKey,
          territoryNameKey = _this$props3.territoryNameKey,
          continentNameKey = _this$props3.continentNameKey,
          formatMessage = _this$props3.formatMessage,
          messages = _this$props3.messages;
      var selectedCountriesNumber = selectedCountries.length;
      var _this$state = this.state,
          searchQuery = _this$state.searchQuery,
          searchedCountries = _this$state.searchedCountries;
      var buttonClasses = cx({
        'TerritoriesListManager-move-button': true,
        'Opm-border-radius': true,
        hide: selectedCountriesNumber <= 0
      });
      var undoLinkClasses = cx({
        'TerritoriesListManager-undo-message': true,
        'Opm-thin-grey-border': true,
        hide: !this.getUndoLinkStatus()
      });
      return React.createElement("div", {
        className: "TerritoriesListManager col-xs-6",
        id: thisListType
      }, React.createElement("div", {
        className: "TerritoriesListManager-list Opm-thin-grey-border Opm-border-radius"
      }, React.createElement(ListHeader, {
        header: header,
        selectedCountriesNumber: countries.length,
        totalCountriesNumber: totalNumberOfCountries,
        onTerritorySelect: onCountrySelect,
        onCountrySearch: this.handleTerritorySearch,
        onCountrySearchClose: this.handleTerritorySearchClose,
        searchQuery: searchQuery,
        formatMessage: formatMessage,
        messages: messages
      }), React.createElement("div", {
        className: "TerritoriesListManager-territories-list"
      }, React.createElement(TerritoriesList, {
        onCountrySelect: onCountrySelect,
        territories: searchedCountries,
        selectedCountries: selectedCountries,
        expandAll: searchQuery.length !== 0,
        theOtherListLabel: theOtherListLabel,
        territoryIdKey: territoryIdKey,
        territoryNameKey: territoryNameKey,
        continentNameKey: continentNameKey,
        formatMessage: formatMessage,
        messages: messages
      }))), React.createElement("div", {
        className: undoLinkClasses
      }, React.createElement(UndoLink, {
        handleUndoChanges: onTerritoryMovedUndo,
        handleNotificationClose: onUndoNotificationClose,
        movedCountriesNumber: movedCountriesNumber,
        formatMessage: formatMessage,
        messages: messages
      })), React.createElement("div", {
        className: buttonClasses
      }, React.createElement(MoveCountryButton, {
        thisListType: thisListType,
        theOtherListType: theOtherListType,
        selectedCountriesNumber: selectedCountriesNumber,
        onCountryMove: onTerritoryMove,
        forward: forward,
        theOtherListLabel: theOtherListLabel,
        formatMessage: formatMessage,
        messages: messages
      })));
    }
  }]);

  return TerritoriesListManager;
}(Component);

_defineProperty(TerritoriesListManager, "propTypes", {
  header: PropTypes.string.isRequired,
  thisListType: PropTypes.string.isRequired,
  theOtherListType: PropTypes.string.isRequired,
  onUndoNotificationClose: PropTypes.func,
  undoNotificationVisible: PropTypes.bool,
  totalNumberOfCountries: PropTypes.number.isRequired,
  countries: PropTypes.array.isRequired,
  selectedCountries: PropTypes.array.isRequired,
  movedCountriesNumber: PropTypes.number,
  onTerritoryMovedUndo: PropTypes.func,
  onTerritorySearchClose: PropTypes.func,
  onTerritoryMove: PropTypes.func.isRequired,
  onCountrySelect: PropTypes.func.isRequired,
  theOtherListLabel: PropTypes.string.isRequired,
  forward: PropTypes.bool.isRequired,
  formatMessage: PropTypes.func.isRequired,
  messages: PropTypes.shape({
    countriesCounterOf: PropTypes.object,
    emptyListLabel: PropTypes.object,
    emptyListLabelFrom: PropTypes.object,
    emptyListDescription: PropTypes.object,
    searchPlaceholder: PropTypes.object,
    selectAllLabel: PropTypes.object,
    selectNoneLabel: PropTypes.object,
    undoDescription: PropTypes.object,
    undoLabel: PropTypes.object,
    moveSelectedLabel: PropTypes.object,
    moveToLabel: PropTypes.object
  }).isRequired,
  territoryIdKey: PropTypes.string,
  territoryNameKey: PropTypes.string,
  continentNameKey: PropTypes.string
});

_defineProperty(TerritoriesListManager, "defaultProps", {
  territoryIdKey: TERRITORIES_KEYS.ID,
  territoryNameKey: TERRITORIES_KEYS.NAME,
  continentNameKey: TERRITORIES_KEYS.CONTINENT
});

export default TerritoriesListManager;